import getFlattenedConfiguration from '../../redux/selectors/getFlattenedConfiguration';

const resolvePrice = (part, serialParentUid, configuration) => {
    if (serialParentUid !== 0) {
        const flattenedConfiguration =
      getFlattenedConfiguration(configuration);
        const foundParent = flattenedConfiguration.filter(
            (selectedItem) => selectedItem.uid === serialParentUid
        );
        if (foundParent.length > 0) {
            return 0;
        }
    }
    return part.total_price;
};
export default resolvePrice;
